<template>
  <span
    v-if="wuenscheMitBezGR.length > 0"
    v-b-tooltip.hover.right="{
      title: tooltipHtml,
      html: true,
      customClass: 'gr-wunsch-tooltip',
    }"
    class="text-danger d-inline-flex"
    style="cursor: pointer"
  >
    <UsersRound :size="16" />
  </span>
</template>

<script>
import { UsersRound } from 'lucide-vue';

export default {
  components: { UsersRound },
  props: {
    teilnehmers: { type: Array, default: () => [] },
  },
  computed: {
    wuenscheMitBezGR() {
      // Sammelt eindeutige Wunsch-Texte aller Teilnehmer mit bez === 'GR'
      const alleWuensche = this.teilnehmers.flatMap(teilnehmer =>
        (teilnehmer.kundenwuensche ?? [])
          .filter(kundenwunsch => kundenwunsch.bez === 'GR')
          .map(kundenwunsch => kundenwunsch.wunsch)
      );
      return [...new Set(alleWuensche)];
    },
    tooltipHtml() {
      return this.wuenscheMitBezGR.map(wunsch => `<div>${wunsch}</div>`).join('');
    },
  },
};
</script>

<style>
.gr-wunsch-tooltip.tooltip {
  opacity: 1 !important;
}

.gr-wunsch-tooltip .tooltip-inner {
  max-width: 400px;
  text-align: left;
  padding: 8px 8px;
}
</style>
